export const getUserType = () => {
  return sessionStorage.getItem('sc_userType') || USER_TYPES.INSURED
}

export const setUserType = (userType = USER_TYPES.INSURED) => {
  return sessionStorage.setItem('sc_userType', userType)
}

export const getUserLocale = () => {
  return localStorage.getItem('locale') || 'fr'
}

export const isInsured = () => getUserType() === USER_TYPES.INSURED
export const isProfessional = () => getUserType() === USER_TYPES.PROFESSIONAL
export const isBillmaInsured = () => getUserType() === USER_TYPES.BILLMA_INSURED
export const isBillmaAgent = () => getUserType() === USER_TYPES.BILLMA_AGENT
export const isBillmaAgentNew = () =>
  getUserType() === USER_TYPES.BILLMA_AGENT_NEW

export const isE2ENew = () => getUserType() === USER_TYPES.E2E_NEW
export const isE2E = () => getUserType() === USER_TYPES.E2E
export const isBillmaUser = () => getUserType() === USER_TYPES.BILLMA_USER
export const isPhotoclaim = () => getUserType() === USER_TYPES.PHOTOCLAIM
//  PC_FLOWS.some((flow) => flow === )
export const isRenProfessional = () =>
  getUserType() === USER_TYPES.REN_PROFESSIONAL
export const isRenInsured = () => getUserType() === USER_TYPES.REN_INSURED
export const isValidUserType = (userType) =>
  Object.values(USER_TYPES).indexOf(userType) > -1
export const isValidUserFlowState = (userFlowState) =>
  Object.values(USER_FLOW_STATES).indexOf(userFlowState) > -1

export const USER_TYPES = {
  INSURED: 'gag_insured',
  PROFESSIONAL: 'damage_professional',
  BILLMA_INSURED: 'damage_billma_insured',
  BILLMA_AGENT: 'damage_billma_agent',
  BILLMA_AGENT_NEW: 'damage_billma_agent_new',
  BILLMA_USER: 'billma_user',
  REN_PROFESSIONAL: 'ren_professional',
  REN_INSURED: 'ren_insured',
  E2E: 'e2e',
  E2E_NEW: 'e2e_new',
  PHOTOCLAIM: 'photoclaim',
  PHOTOCLAIM_CAMERA: 'photoclaim_camera',
  BILLMA_BPCE: 'billma_bpce'
}

export const USER_FLOWS = {
  MANAGE_DAMAGE_GRE_A_GRE_RESPONSE: 'MANAGE_DAMAGE_GRE_A_GRE_RESPONSE',
  MANAGE_DAMAGE_CONTACT_RESPONSE: 'MANAGE_DAMAGE_CONTACT_RESPONSE',
  MANAGE_DAMAGE_APPOINTMENT_RESPONSE: 'MANAGE_DAMAGE_APPOINTMENT_RESPONSE',
  MANAGE_DAMAGE_BILLMA_RESPONSE: 'MANAGE_DAMAGE_BILLMA_RESPONSE'
}

export const USER_FLOW_STATES = {
  KO: 'KO',
  OK: 'OK',
  ERROR: 'ERROR'
}

const PC_FLOWS = [USER_TYPES.PHOTOCLAIM, USER_TYPES.PHOTOCLAIM_CAMERA]
